export enum CREATEFeature {
  UNKNOWN = "unknown",
  READ_MODELS = "create:read-models",
  STORE_MODELS = "create:store-models",
  SIMULATION = "create:simulation",
  GENERATE_CODE = "create:generate-code",
  AI_COPILOT = "create:ai-copilot",
}
